import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@storable/canaveral-components';
import {
  HOME_PAGE,
  TERMS_PAGE,
  PRIVACY_PAGE,
  PAY_ONLINE_PAGE,
  MISC_PAGE,
  FACILITIES_LIST_PAGE,
} from 'shared/pageTypes';
import { sortAlphabetically } from '../../../../data/lib/sort';
import Select from '../../../../modules/react/components/stateful/Select';
import styles from './AdminAddPageModal.scss';

const propTypes = {
  i18nEnabled: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

const defaultProps = {
  i18nEnabled: undefined,
  options: [
    { value: HOME_PAGE, label: 'Home' },
    { value: FACILITIES_LIST_PAGE, label: 'All Locations' },
    { value: MISC_PAGE, label: 'Misc. Page' },
    { value: PAY_ONLINE_PAGE, label: 'Pay Online' },
    { value: TERMS_PAGE, label: 'Terms and conditions' },
    { value: PRIVACY_PAGE, label: 'Privacy' },
  ],
};

const sortOptions = (x, y) => sortAlphabetically(x.label, y.label);

class AdminAddPageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  onPageChange = ({ value }) => this.setState({
    value,
  })

  onSubmit = () => {
    const { onSubmit, onDismiss } = this.props;
    const { value } = this.state;

    onSubmit(value);
    onDismiss();
  }

  render() {
    const {
      i18nEnabled, options, onDismiss, show,
    } = this.props;

    return (
      <Modal
        show={show}
        onDismiss={onDismiss}
        aria-labelledby="admin-add-page"
      >
        <Modal.Header>
          <Modal.Title id="admin-add-page">Add Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Select the type of page you want to add.</strong></p>
          <p>If you want to add a facility page, please contact support.</p>
          <Select
            autoBlur
            clearable={false}
            options={options.sort(sortOptions)}
            placeholder="Page type"
            value={this.state.value}
            className={styles.select}
            onChange={this.onPageChange}
          />
          {i18nEnabled && (
            <p className={styles.multilanguage}>
              This will only add the English (US) version of this page. You can
              enable the other languages from this new page.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" context="neutral" onClick={onDismiss}>Close</Button>
          <Button size="sm" context="positive" onClick={this.onSubmit}>Add Page</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AdminAddPageModal.propTypes = propTypes;
AdminAddPageModal.defaultProps = defaultProps;

export default AdminAddPageModal;
